import { BehaviorSubject, Observable } from 'rxjs';
import { IEnvironment } from './types';
import { NamingMapping } from 'src/components/visionx/super-admin/tenants/types';

class EnvironmentService {
  protected environment: IEnvironment | null = null;
  protected environmentSubject: BehaviorSubject<IEnvironment> = new BehaviorSubject<IEnvironment>({
    loaded: false,
  } as IEnvironment);

  public getEnvironment = (): IEnvironment | null => {
    return this.environment;
  };
  public setEnvironment = (environment: IEnvironment | null): void => {
    this.environment = environment;
    if (environment) {
      this.environmentSubject.next(environment);
    }
  };

  public watchEnvironment = (): Observable<IEnvironment> => {
    return this.environmentSubject?.asObservable();
  };

  public setHomePage(homePage?: string) {
    if (homePage && this.environment) {
      sessionStorage.setItem('homePage', homePage as string);
      this.environment.homePage = homePage;
    }
  }

  public setSiemType(siemType?: string) {
    if (siemType && this.environment) {
      sessionStorage.setItem('siemType', siemType as string);
      this.environment.siemType = siemType;
    }
  }

  public setTotpSetup(totpSetup?: boolean) {
    if (this.environment) {
      sessionStorage.setItem('totpSetup', JSON.stringify(totpSetup));
      this.environment.totpSetup = totpSetup;
    }
  }

  public setAppMode(appMode?: string) {
    if (appMode && this.environment) {
      sessionStorage.setItem('appMode', appMode as string);
      this.environment.appMode = appMode;
      this.environment.applicationMode = appMode;
    }
  }

  public setNamingMapping(namingMapping?: NamingMapping) {
    if (namingMapping && this.environment) {
      this.environment.namingMapping = namingMapping;
    }
  }

  public setTHDisplay(threatHubDisplay?: string) {
    if (threatHubDisplay && this.environment) {
      this.environment.threatHubDisplay = threatHubDisplay;
    }
  }

  public setMttrDisplay(mttrDisplay?: string) {
    if (mttrDisplay && this.environment) {
      this.environment.mttrDisplay = mttrDisplay;
    }
  }

  public setGetVizDisplay(getVisibilityEnabled?: boolean) {
    if (getVisibilityEnabled && this.environment) {
      this.environment.getVisibilityEnabled = getVisibilityEnabled;
    }
  }

  public setWizDisplay(wizFeatureEnabled?: boolean) {
    if (wizFeatureEnabled && this.environment) {
      this.environment.wizFeatureEnabled = wizFeatureEnabled;
    }
  }

  public setSplunkMttxDisplay(splunkMTTXFeatureEnabled?: boolean) {
    if (splunkMTTXFeatureEnabled && this.environment) {
      this.environment.splunkMTTXFeatureEnabled = splunkMTTXFeatureEnabled;
    }
  }

  public setDefenderSecureScoreDisplay(defenderFeatureEnabled?: boolean) {
    if (defenderFeatureEnabled && this.environment) {
      this.environment.defenderFeatureEnabled = defenderFeatureEnabled;
    }
  }

  public setNoPhishFeatureEnabled(noPhishFeatureEnabled?: boolean) {
    if (noPhishFeatureEnabled && this.environment) {
      this.environment.noPhishFeatureEnabled = noPhishFeatureEnabled;
    }
  }

  public setTenantShortName(tenantShortName?: string) {
    if (tenantShortName && this.environment) {
      this.environment.tenantShortName = tenantShortName;
    }
  }
  public setTimeToIdle(timeToIdle?: string) {
    if (timeToIdle && this.environment) {
      this.environment.timeToIdle = timeToIdle;
    }
  }

  public setJiraIncidentsFeatureEnabled(jiraIncidentsFeatureEnabled?: boolean) {
    if (this.environment) {
      this.environment.jiraIncidentsFeatureEnabled = jiraIncidentsFeatureEnabled;
    }
  }

  public setCisoTrainingFeature(cisoTrainingFeature?: boolean) {
    if (this.environment) {
      this.environment.cisoTrainingFeature = cisoTrainingFeature;
    }
  }

  public setSentinelOneFeatureEnabled(sentinelOneFeatureEnabled?: boolean) {
    if (this.environment) {
      this.environment.sentinelOneFeatureEnabled = sentinelOneFeatureEnabled;
    }
  }

  public setSentinelMttxFeatureEnabled(sentinelMttxFeatureEnabled?: boolean) {
    if (this.environment) {
      this.environment.sentinelMttxFeatureEnabled = sentinelMttxFeatureEnabled;
    }
  }
}

const environmentService = new EnvironmentService();

export { environmentService };

export default EnvironmentService;
